import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PUBLIC_URL } from '../config/routes';
import '../styles/Navbar.css';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src={`${PUBLIC_URL}/logo/425211498110021632.png`} alt="SCL Networks Logo" />
        </Link>

        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <i className="fas fa-times close-menu" onClick={toggleMenu}></i>
          <ul>
            <li>
              <Link to="/" className={isActive('/') && !isActive('/services') ? 'active' : ''}>
                Home
              </Link>
            </li>
            <li className="services-dropdown">
              <div 
                className={`services-link ${isActive('/services') ? 'active' : ''}`}
                onClick={toggleServicesDropdown}
              >
                Services <i className={`fas fa-chevron-down ${isServicesDropdownOpen ? 'rotate' : ''}`}></i>
              </div>
              <ul className={`dropdown-menu ${isServicesDropdownOpen ? 'show' : ''}`}>
                <li>
                  <Link to="/services/web-development">
                    <i className="fas fa-code"></i>
                    Web Development
                  </Link>
                </li>
                <li>
                  <Link to="/services/responsive-design">
                    <i className="fas fa-mobile-alt"></i>
                    Responsive Design
                  </Link>
                </li>
                <li>
                  <Link to="/services/ecommerce-solutions">
                    <i className="fas fa-shopping-cart"></i>
                    E-commerce Solutions
                  </Link>
                </li>
                <li>
                  <Link to="/services/web-development#maintenance">
                    <i className="fas fa-server"></i>
                    Website Maintenance
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/portfolio" className={isActive('/portfolio') ? 'active' : ''}>
                Portfolio
              </Link>
            </li>
            <li>
              <Link to="/about" className={isActive('/about') ? 'active' : ''}>
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <i className="fas fa-bars menu-icon" onClick={toggleMenu}></i>
      </div>
    </header>
  );
};

export default Navbar; 